module.exports = __webpack_public_path__ + "static/media/noBestDish2.7f84be43.png";